import React from 'react';
import style from '../../constants/accountStyle'


const Landing = () => (
  <div style={style.div}>
    <h1 style={style.h1}>Welcome to ClassTasks!</h1>
    <p style={style.p}>
      To get started sign in or make a new account, then go to the classes page.
    </p>
  </div>
);

export default Landing;
